import React from 'react';
import { Link } from '@/components/LocalizedLink';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const QUICK_LINKS = [
  { to: '/about', label: 'About Us' },
  { to: '/products', label: 'Products' },
  { to: '/why-choose-us', label: 'Why Choose Us' },
  { to: '/export-markets', label: 'Export Markets' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

const FOOTER_PRODUCTS = [
  ['turmeric', 'Turmeric Powder'], ['red-chilli', 'Red Chilli Powder'], ['coriander', 'Coriander Powder'],
  ['garlic', 'Garlic Powder'], ['cumin', 'Cumin Powder'], ['black-pepper', 'Black Pepper Powder'],
];

const HEADING = 'font-sans font-semibold text-white text-sm uppercase tracking-wider mb-4';
const LINK = 'block text-sm text-cream-muted/70 hover:text-saffron transition-colors font-sans';
const CONTACT = 'flex items-start gap-2 text-sm text-cream-muted/70 font-sans';

export function FooterBrand({ logoUrl }) {
  return (
    <div>
      <img src={logoUrl} alt="ASJK Laxmi Global" width={1179} height={1085} loading="lazy" className="h-14 w-auto max-w-[200px] object-contain mb-4 rounded-lg bg-white/90 p-1.5" data-testid="footer-logo-image" />
      <p className="text-sm text-cream-muted/80 font-sans leading-relaxed">
        Premium Indian spice powder exporter. Farm-to-export traceability with FSSAI-compliant quality and competitive FOB pricing.
      </p>
      <a href="https://www.asjklaxmiglobal.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs text-saffron font-sans font-semibold mt-3 hover:text-saffron-light transition-colors" data-testid="website-link">
        <ExternalLink size={11} /> www.asjklaxmiglobal.com
      </a>
    </div>
  );
}

export function QuickLinks() {
  return (
    <div>
      <h4 className={HEADING}>Quick Links</h4>
      <div className="space-y-2">
        {QUICK_LINKS.map(link => <Link key={link.to} to={link.to} className={LINK}>{link.label}</Link>)}
      </div>
    </div>
  );
}

export function ProductLinks() {
  return (
    <div>
      <h4 className={HEADING}>Our Spice Powders</h4>
      <div className="space-y-2">
        {FOOTER_PRODUCTS.map(([slug, name]) => (
          <Link key={slug} to={`/products/${slug}`} className={LINK} data-testid={`footer-product-${slug}`}>{name}</Link>
        ))}
      </div>
    </div>
  );
}

export function ContactInfo() {
  return (
    <div>
      <h4 className={HEADING}>Contact Us</h4>
      <div className="space-y-3">
        <a href="mailto:asjklaxmiglobal@gmail.com" className={`${CONTACT} hover:text-saffron transition-colors`}>
          <Mail size={14} className="mt-0.5 flex-shrink-0" /> asjklaxmiglobal@gmail.com
        </a>
        <a href="tel:+919284548218" className={`${CONTACT} hover:text-saffron transition-colors`}>
          <Phone size={14} className="mt-0.5 flex-shrink-0" /> +91 92845 48218
        </a>
        <div className={CONTACT}>
          <MapPin size={14} className="mt-0.5 flex-shrink-0" />
          <span>Nashik T Point, Chhatrapati Sambhajinagar, Maharashtra 431115, India</span>
        </div>
      </div>
    </div>
  );
}
